// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f8ff1656","304":"cb4eacdd","453":"825386d9"}[chunkId] + ".chunk.js";
};